import { timezone } from "./constant";

export const greetings = () => {
    let myDate = new Date();
    let hours = myDate.getHours();
    var greet;
    if (hours < 12) greet = "morning";
    else if (hours >= 12 && hours <= 17) greet = "afternoon";
    else if (hours >= 17 && hours <= 24) greet = "evening";
    return `Good ${greet}`;
};

export const getTz = (tz: any) => {
    var timezonetype = "";
    for (let i = 0; i < timezone.length; i++) {
        timezone[i].fullName === tz && (timezonetype = timezone[i].name);
    }
    return timezonetype;
};